var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('AppBar'),_c('v-main',[_c('div',{staticClass:"card-container"},[_c('v-card',[_c('v-card-title',[_vm._v("Not an admin?")]),_c('v-progress-linear',{attrs:{"color":"primary","value":100}}),_c('v-card-text',[_vm._v(" Overseer is reserved to admins only! Use an admin account to connect and use this website :) ")])],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }